import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { ShipmentsService } from "../services/shipments.service"
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-print-shipment',
  templateUrl: './print-shipment.component.html',
  styleUrls: ['./print-shipment.component.css']
})
export class PrintShipmentComponent implements OnInit {
  isLoggedIn$: Observable<boolean>
  bolqtid;
  shipment;
  shipitems;
  loaded = false;

  constructor(private route: ActivatedRoute, 
              private router: Router,
              private shipmentsService: ShipmentsService,
              private authService: AuthService  ) {
    // this.authService.getUser().subscribe(
    //   user => {
    //     //get isLogged in if a user.userid is returned
    //     if(user.userid) { 
    //       this.isLoggedIn$ = this.authService.isLoggedIn$
    //       console.log('signed in current')
    //     }else {
    //       console.log('Not current or signed in')
    //       this.router.navigateByUrl('/signin')
    //     }
    //   }
    // )
    }

  ngOnInit() {
    this.isLoggedIn$ = this.authService.isLoggedIn$
    
    this.route.params
    .subscribe(
      (params: Params) => {
        this.bolqtid = + params['bol'];
        // load
        this.getVwShipments(this.bolqtid);
        this.getShipItems(this.bolqtid);
      }
    );

    
  }

  getVwShipments(bolqtid){
    // get the bol info from vwshipments from shipments_services
    this.shipmentsService.getVwShipments(bolqtid)
    .then(shipment => {
      this.shipment = JSON.parse(shipment._body)
      this.shipment = this.shipment[0];
    })
  }

  getShipItems(bolqtid) {
    this.shipmentsService.getShipItems(bolqtid)
    .then(shipitems => {
      console.log(shipitems)
      this.shipitems = JSON.parse(shipitems._body);
      console.log(this.shipitems)
      this.loaded = true;
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/print-shipment/print-shipment.component.ts